// frontend/src/pages/FranchisingPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import TornaAlMenu from "../components/TornaAlMenu";

const API_URL = process.env.REACT_APP_API_URL || "";

export default function FranchisingPage() {
  const nav = useNavigate();
  const [role, setRole] = useState("");
  const isMadre = role === "MADRE";

  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("access");
        const headers = { Authorization: `Bearer ${token}` };

        const me = await fetch(`${API_URL}/api/me/`, { headers }).then(r => r.json());
        setRole((me?.role || "").toUpperCase());

        const res = await fetch(`${API_URL}/api/franchising/`, { headers });
        const data = await res.json();
        if (!res.ok) throw new Error(data?.detail || "Errore caricamento franchising");
        setRows(Array.isArray(data) ? data : []);
      } catch (e) {
        setErr(e.message || "Errore");
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return rows;
    return rows.filter(r =>
      [
        r.code, r.name, r.referent, r.address,
        r.fatt_ragione_sociale, r.fatt_piva, r.fatt_cf, r.fatt_email, r.telefono,
      ]
        .map(v => String(v || "").toLowerCase())
        .some(v => v.includes(term))
    );
  }, [rows, q]);

  return (
    <div className="container mt-4">
      <TornaAlMenu to="/" />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="m-0">🏬 Franchising</h2>
        {isMadre && (
          <Link to="/franchising/nuovo" className="btn btn-primary">
            ➕ Nuovo franchising
          </Link>
        )}
      </div>

      <div className="card shadow-sm mb-3">
        <div className="card-body">
          <div className="row g-3 align-items-end">
            <div className="col-md-6">
              <label className="form-label mb-1">Cerca</label>
              <input className="form-control" placeholder="🔎 codice, nome, P.IVA, email…" value={q} onChange={e => setQ(e.target.value)} />
            </div>
          </div>
        </div>
      </div>

      {err && <div className="alert alert-danger">{err}</div>}
      {loading ? (
        <p className="text-muted">Caricamento…</p>
      ) : filtered.length === 0 ? (
        <div className="alert alert-info">Nessun franchising trovato.</div>
      ) : (
        <div className="table-responsive">
          <table className="table align-middle">
            <thead>
              <tr>
                <th style={{width: 110}}>Codice</th>
                <th>Nome</th>
                <th>Referente</th>
                <th>Telefono</th>
                <th>Email fatt.</th>
                <th>P.IVA</th>
                <th style={{width: 220}}>Azioni</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(f => (
                <tr key={f.id}>
                  <td><span className="badge bg-secondary">{f.code}</span></td>
                  <td>{f.name}</td>
                  <td>{f.referent || "-"}</td>
                  <td>{f.telefono || "-"}</td>
                  <td>{f.fatt_email || "-"}</td>
                  <td>{f.fatt_piva || "-"}</td>
                  <td className="d-flex gap-2">
                    {/* Lettura per tutti */}
                    <button className="btn btn-sm btn-outline-dark" onClick={() => nav(`/franchising/${f.id}`)}>
                      Apri
                    </button>
                    {/* Modifica solo MADRE */}
                    {isMadre && (
                      <button className="btn btn-sm btn-primary" onClick={() => nav(`/franchising/${f.id}/edit`)}>
                        Modifica
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
